import React from 'react';
import { Card, Empty, Timeline } from 'antd';
import moment from 'moment';

export default function OrderTimeline(props) {
    const history = Array.isArray(props.history) ? props.history : [];

    return (
        <Card title="Lịch sử thao tác">
            {history.length === 0 ? (
                <Empty description="Chưa có lịch sử" />
            ) : (
                <Timeline>
                    {history.map((item) => (
                        <Timeline.Item key={item._id || `${item.action}-${item.created_time}`}>
                            <div><strong>{item.action}</strong></div>
                            <div>{item.actor && item.actor.name ? item.actor.name : 'Unknown'}</div>
                            <div>{moment(item.created_time).format('HH:mm DD-MM-YYYY')}</div>
                        </Timeline.Item>
                    ))}
                </Timeline>
            )}
        </Card>
    );
}
